/**
 * Textos legais do onboarding.
 *
 * São dois aceites separados de propósito:
 *
 *  1. Termos e disclaimer — o texto obrigatório da seção 16 da
 *     especificação, sobre responsabilidade clínica.
 *  2. Consentimento de dados de saúde — exigência da LGPD que a
 *     especificação não cobre. Foto corporal, peso, IMC, ciclo menstrual
 *     e função intestinal são dado pessoal sensível (art. 5º, II) e
 *     exigem consentimento "específico e destacado" (art. 11, I).
 *     Embutir isso nos termos de uso descaracteriza o destaque.
 *
 * Ao alterar qualquer um destes textos, incremente a versão
 * correspondente em src/tipos/dominio.ts: a mudança de versão obriga
 * um novo aceite, e é isso que mantém a trilha de auditoria válida.
 */

/** Texto literal da seção 16 da especificação. Não editar sem a Raquel. */
export const DISCLAIMER = `As informações compartilhadas no Projeto Viver têm caráter educativo e têm como base práticas de terapias integrativas e complementares. Não constituem prescrição médica ou nutricional, nem substituem acompanhamento profissional individualizado. Consulte um médico ou nutricionista antes de iniciar qualquer protocolo, especialmente se você tiver alguma condição de saúde pré-existente.`

export const TERMOS_RESUMO = [
  'O conteúdo do programa é educativo e não substitui acompanhamento médico ou nutricional.',
  'O acesso é pessoal e intransferível, válido durante a turma em que você está matriculada.',
  'Você pode sair do programa e pedir a exclusão dos seus dados a qualquer momento.',
]

export const CONSENTIMENTO_SAUDE_TITULO = 'Autorização para tratar seus dados de saúde'

export const CONSENTIMENTO_SAUDE = `Para acompanhar sua evolução ao longo dos 28 dias, o Projeto Viver precisa registrar informações que a Lei Geral de Proteção de Dados classifica como dado pessoal sensível de saúde:`

export const DADOS_SENSIVEIS_COLETADOS = [
  { rotulo: 'Fotos de "antes" e "depois"', detalhe: 'guardadas em área privada, só você tem acesso' },
  { rotulo: 'Peso, altura e IMC', detalhe: 'para acompanhar sua evolução' },
  { rotulo: 'Sono, energia, humor, fome e intestino', detalhe: 'registrados no diário diário' },
  { rotulo: 'Ciclo menstrual', detalhe: 'opcional, só se você quiser informar' },
]

export const CONSENTIMENTO_SAUDE_GARANTIAS = [
  'Seus dados são usados só para o seu acompanhamento dentro do programa.',
  'Suas fotos ficam em área privada e não são acessadas pela administração do programa.',
  'Nada é vendido, compartilhado com terceiros ou usado para publicidade.',
  'Você pode revogar esta autorização e pedir a exclusão dos seus dados quando quiser.',
]
